<template>
  <div class="mt-3">
    <div class="flex justify-content-between align-items-center mb-2">
      <span class="md-section-title">{{ title }}</span>
    </div>
    <div v-if="displayCards.length" class="grid">
      <div
        v-for="card in displayCards"
        :key="`${idPrefix}-${card.title}`"
        class="col-12 sm:col-6 xl:col-3"
      >
        <StatCard
          :title="card.title"
          :content-str="card.value"
          card-type="minimal"
          :loader="card.loader"
        />
      </div>
    </div>
    <div v-else class="md-empty">
      {{ loading ? loadingMessage : emptyMessage }}
    </div>
  </div>
</template>

<script setup>
import { defineProps, computed } from "vue";
import StatCard from "@/components/AdminNewDashboard/AdminNewDashboardComponents/StatCard.vue";

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  cards: {
    type: Array,
    default: () => [],
  },
  loading: {
    type: Boolean,
    default: false,
  },
  loadingMessage: {
    type: String,
    default: "Loading metrics...",
  },
  emptyMessage: {
    type: String,
    default: "No metrics available.",
  },
  idPrefix: {
    type: String,
    default: "metric",
  },
  placeholderLabels: {
    type: Array,
    default: () => [],
  },
});

const displayCards = computed(() => {
  if (props.cards.length) {
    return props.cards.map((card, index) => ({
      title: card.title ?? `metric-${index}`,
      value: card.value ?? "",
      loader: props.loading ? 1 : 0,
    }));
  }
  if (props.loading) {
    return props.placeholderLabels.map((label) => ({
      title: label,
      value: "",
      loader: 1,
    }));
  }
  return [];
});
</script>

<style scoped>
.md-empty {
  border: 1px dashed var(--surface-border);
  border-radius: 12px;
  padding: 1.25rem;
  text-align: center;
  font-size: 0.9rem;
  color: var(--text-color-secondary);
  background: var(--surface-ground);
}

.md-section-title {
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-color-secondary);
}
</style>
